export default {
  product: {
    nameRequired: '商品名を入力してください',
    priceRequired: '商品価格を入力してください',
    pricePositive: '商品価格は0より大きくなければなりません',
  },
};
